module.exports = __webpack_public_path__ + "img/Icon-Zoom-out.3a193a59.svg";